import { IOnboardingItem } from "./onboarding-progress.helpers";

export const onboardingItems: IOnboardingItem[] = [
  { id: "wizard", label: "Onboarding Wizard", status: "complete" },
  {
    id: "security-stack",
    label: "Mapped Security Stack",
    status: "complete",
  },
  {
    id: "security-package",
    label: "Built a Security Package",
    status: "in-progress",
  },
  {
    id: "integrations",
    label: "Integrations",
    status: "not-started",
    children: [
      { id: "rmm", label: "RMM", status: "not-connected" },
      { id: "psa", label: "PSA", status: "not-connected" },
      {
        id: "lighthouse",
        label: "Microsoft Lighthouse",
        status: "not-connected",
      },
    ],
  },
  {
    id: "storefront",
    label: "Created a Product in Storefront",
    status: "not-started",
  },
  { id: "proposal", label: "Sent a Proposal", status: "complete" },
  { id: "report", label: "Sent a Client Report", status: "not-started" },
];

